import Page from "webPage/Page";
import NewsAndEventsHandler from "../NewsAndEventsHandler";

Page.register('/news-and-events', () => {
    new NewsAndEventsHandler();

    $("body").on("click", ".js-scroll-upcoming", function () {
        let direction = $(this).attr('data-direction');

        let $first = $(".upcoming__body .upcoming-article").first();

        let itemWidth = $first.outerWidth() + parseInt($first.css("margin-right"));

        let current = Math.floor($(".upcoming__scroll-wrap .simplebar-content").scrollLeft() / itemWidth);

        let next = Math.min($(".upcoming__body .upcoming-article").length, Math.max(0, current + (direction == 'back' ? -1 : 1)));

        $(".upcoming__scroll-wrap .simplebar-content").stop().animate({scrollLeft: next * itemWidth});
        return false;
    });
});
